import { AppFunctionGroup } from './app-function-group';
import { AppFunction } from './app-function';

export interface User {
  id: number;
  username: string;
  password: string;
  name: string;
  lastLogin: string;
  email: string;
  profileImage: string;
  status: number;
  appFunctionGroups: Array<AppFunctionGroup>;
  appFunctions: Array<AppFunction>;
  displayStatus: string;
  organization_id: number;
  invitation_count: number;
  last_invitation_date: string;
  invitation_status: number;
  invitation_token: string;
  app_functions: Array<any>;
  dashboard_settings: string;
}

export class User {

  constructor(withZero: boolean = false) {

    if(withZero === true) {
        this.id = 0;
    }
    else {
      this.id = null;
    }
    this.username = '';
    this.password = null;
    this.name = '';
    this.status = 1;
    this.organization_id = null;
  }
}
